import { useState } from 'react';

import { getStorageValue, setStorageValue } from '@helpers/storage';
import { StorageValues, StorageTypes } from '@interfaces/storage';
import { log } from './Debug';
import { visualizeAudio } from './AudioVisualizer';
import { assistantSize } from '@core/assistant/constants';
import AssistantQueryService from '@services/AssistantQueryService';

export const useGreetings = () => {
  const [isGreetingsPlayback, setIsGreetingsPlayback] = useState(false);

  const generateGreetingsAudio = async () => {
    log('generateGreetingsAudio clicked');

    let arrayBuffer: ArrayBuffer | null = null;

    try {
      arrayBuffer = await AssistantQueryService.generateAssistantAudio({
        text: 'Hello, I am Noa, your AI assistant',
        disableOptimizations: true,
      });
    } catch (e) {
      console.warn('Error: failed to fetch Polly audio', e);
      return;
    }

    if (!arrayBuffer || arrayBuffer.byteLength === 0) {
      console.warn('Error: empty or missing Polly audio response');
      return;
    }

    console.log(
      `Polly audio size before playback: ${(
        arrayBuffer.byteLength / 1024
      ).toFixed(2)} KB`,
    );

    let visualizerInstance: any;

    if (visualizerInstance) {
      visualizerInstance.stopAudio();
    }
    visualizerInstance = visualizeAudio(
      assistantSize.width,
      assistantSize.height,
      () => {},
    );
    visualizerInstance = visualizerInstance.initialize(arrayBuffer);
  };

  return {
    generateGreetingsAudio,
    isGreetingsPlayback,
    setIsGreetingsPlayback,
  };
};
